import React from 'react';
import PropTypes from 'prop-types';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Button from '@material-ui/core/Button';
import { withRouter } from 'react-router-dom';

import './backButton.less';

class BackButton extends React.Component {
  onClick = () => {
    const { history, to } = this.props;
    if (to) {
      history.replace(to);
      return;
    }

    history.goBack();
  }

  render() {
    return (
      <div className="back-button">
        <Button onClick={this.onClick}>
          <ArrowBackIcon />
          <div>Wstecz</div>
        </Button>
      </div>
    );
  }
}

BackButton.propTypes = {
  history: PropTypes.shape({
    goBack: PropTypes.func,
    replace: PropTypes.func,
  }).isRequired,
  to: PropTypes.string,
};

BackButton.defaultProps = {
  to: undefined,
};

export default withRouter(BackButton);
